import './WorkLogCard.css';
import WorkLogCardItem from './WorkLogCardItem';
import addNewItemIcon from './images/upload-item.svg';
export default function WorkLogCard({
  title,
  items,
  type,
  handleShowWorkLogModal,
  activeItem,
  setActiveItem,
  handleItemListRemoval,
}) {
  return (
    <div className="worklog-details">
      <div className="worklog-title">{title}</div>

      <div
        className="worklog-container"
        onClick={() => setActiveItem(null)}
        style={{ height: type === 'materials' && '270px' }}
      >
        {items.length > 0 ? (
          <div className="worklog-items">
            {items.map((item, index) => (
              <WorkLogCardItem
                key={index}
                id={index}
                item={item}
                type={type}
                activeItem={activeItem}
                setActiveItem={setActiveItem}
                handleItemListRemoval={handleItemListRemoval}
              />
            ))}
          </div>
        ) : (
          <div className="worklog-empty-list">Lista je prazna</div>
        )}

        <div
          className="worklog-new-item"
          onClick={() => handleShowWorkLogModal(type)}
        >
          <img src={addNewItemIcon} alt="Icon" height="14" width="14" />
        </div>
      </div>
    </div>
  );
}
